import React, { useState } from "react";
import AppTabs from "../../../../components/AppTabs";
import DocsNiceToKnow from "../../shared/DocsNiceToKnow";
import DocsPreviewPanel from "../../shared/DocsPreviewPanel";
import DocsSectionCard from "../../shared/DocsSectionCard";

const tabItems = [
  { key: "overview", label: "Übersicht" },
  { key: "availability", label: "Verfügbarkeit" },
  { key: "settings", label: "Einstellungen" },
];

const niceToKnowItems = [
  "PAGE = sitzt direkt auf dem Page-Hintergrund, Linie läuft über die volle Containerbreite.",
  "CONTAINED = sitzt in Cards, Listen, etc, Tabs füllen die Breite gleichmässig.",
  "Icons, Counts oder Sizes sind aktuell nicht als offizieller Tab-Standard definiert.",
];

function PreviewRow({ label, children }) {
  return (
    <div className="ds-docs-preview-row">
      <div className="ds-docs-preview-row__label">{label}</div>
      <div className="ds-docs-preview-row__content">{children}</div>
    </div>
  );
}

export default function TabsDocs() {
  const [pageActiveKey, setPageActiveKey] = useState("overview");
  const [containedActiveKey, setContainedActiveKey] = useState("overview");

  return (
    <DocsSectionCard title="Tabs">
      <div className="ds-docs-spotlight-grid">
        <DocsPreviewPanel>
          <div className="ds-docs-preview-surface ds-docs-tabs-preview">
            <PreviewRow label="Page">
              <AppTabs items={tabItems} activeKey={pageActiveKey} onChange={setPageActiveKey} variant="page" />
            </PreviewRow>

            <PreviewRow label="Contained">
              <div className="ds-docs-tabs-preview__contained">
                <AppTabs
                  items={tabItems}
                  activeKey={containedActiveKey}
                  onChange={setContainedActiveKey}
                  variant="contained"
                />
              </div>
            </PreviewRow>
          </div>
        </DocsPreviewPanel>

        <DocsNiceToKnow items={niceToKnowItems} />
      </div>
    </DocsSectionCard>
  );
}
